import { PaymentMethod } from "common";
import { PaymentKey } from "pages/Payment/config";

export const validationFileSize = (file: File, maxSize: number) => {
  const { size } = file;
  return size <= maxSize;
};

export const getVerifyFileName = (
  fileName: string,
  fileType: PaymentKey,
  serviceProviderCode?: string,
  businessUnitCode?: string,
  disbursementDate?: Date,
  paymentType?: string
) => {
  let regex;
  if (fileType === PaymentKey.UPLOAD_PAYROLL_FILE) {
    // Case-insensitive ("i" flag): SAP HCM generates UPPERCASE .CSV and .CSV.GPG extensions
    const regexData = new RegExp(
      `^GOT_${businessUnitCode}_${
        paymentType === PaymentMethod.NORMAL_PAY ? "PREPAID" : "POSTPAID"
      }_DISBURSEMENT_\\d{8}\\.csv(\\.gpg)?$`,
      "i"
    );
    regex = regexData;
  } else if (fileType === PaymentKey.UPLOAD_PROOF_PREFUND) {
    // Case-insensitive ("i" flag): accept UPPERCASE file extensions
    const regexData = new RegExp(
      `^PREFUND_GOT_SMBULK_${serviceProviderCode}_${businessUnitCode}_\\d{8}\\.(png|jpeg|jpg|pdf)$`,
      "i"
    );
    regex = regexData;
  }
  if (regex) {
    const verify = regex.test(fileName);
    return verify;
    // Validate disbursementDate with date format at the end of filename
    // if (disbursementDate) {
    //   const dateMatch = fileName.match(/\d{8}(?=(_|\.\w+)?$)/);
    //   if (dateMatch) {
    //     // Convert the extracted date to a dayjs object
    //     const fileDate = dayjs(dateMatch[0], "YYYYMMDD");
    //     // The date you want to compare with
    //     const chosenDate = dayjs(disbursementDate, "YYYYMMDD");
    //     // Compare the dates

    //     const isSameDate = fileDate.isSame(chosenDate, "day");
    //     console.log("fileDate", fileDate);
    //     console.log("chosenDate", chosenDate);
    //     console.log("dateMatch", dateMatch);
    //     console.log("isSameDate", isSameDate);
    //     return isSameDate;
    //   } else {
    //     return false;
    //   }
    // } else {
    //   return true;
    // }
  }
};

export const verifyUploadBeforeTenAMToday = (
  disbursementDate?: Date
): boolean => {
  // Remove 10 AM restriction - allow uploads at any time
  return true;
};
